'use client';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Grid from '@enlighten/design-system/dist/Grid';
import { useTheme } from '@enlighten/design-system/dist/styles';
import Typography from '@enlighten/design-system/dist/Typography';
import useMediaQuery from '@enlighten/design-system/dist/useMediaQuery';
import Image from 'next/image';
import Slider from 'react-slick';
import CaseImage1 from '../../assets/images/rooftop/section_05_slide_01.png';
import CaseImage2 from '../../assets/images/rooftop/section_05_slide_02.png';
import CaseImage3 from '../../assets/images/rooftop/section_05_slide_03.png';
import CaseImage4 from '../../assets/images/rooftop/section_05_slide_04.png';
import CaseImage5 from '../../assets/images/rooftop/section_05_slide_05.png';
const list = [
    {
        src: CaseImage1,
        alt: `운영중

대구 A공장
임대

1.9 MW`,
    },
    {
        src: CaseImage2,
        alt: `운영중

전남 광양 B공장
임대

1 MW`,
    },
    {
        src: CaseImage3,
        alt: `운영중

제주 C공장
임대

500 kW`,
    },
    {
        src: CaseImage4,
        alt: `운영중

전북 군산 D공장
임대

500 kW`,
    },
    {
        src: CaseImage5,
        alt: `운영중

성주 E공장
임대

1.8 MW`,
    },
];
// @ts-ignore
const SliderComponent = !!Slider.default ? Slider.default : Slider;
export default function RooftopSection5() {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));
    return (_jsxs(Grid, { container: true, direction: "column", alignItems: "center", width: "100%", maxWidth: 1392, marginX: { xs: 0, md: 'auto' }, padding: { xs: '60px 0px 80px 0px', md: '110px 0px 140px 0px' }, children: [_jsx(Grid, { display: "flex", alignItems: "center", border: "1px solid #36D099", height: { xs: 34, md: 38 }, borderRadius: 99, marginBottom: { xs: '20px', md: '16px' }, paddingX: '12px', children: _jsx(Typography, { fontSize: { xs: 14, md: 20 }, fontWeight: 700, textAlign: "center", color: "#36D099", whiteSpace: "nowrap", children: "\uCCAB \uBC88\uC9F8" }) }), _jsx(Typography, { fontSize: { xs: 22, md: 40 }, fontWeight: 700, textAlign: "center", marginBottom: { xs: '12px', md: '16px' }, children: "\uC9C0\uBD95 \uD0DC\uC591\uAD11 \uC2E4\uC801 60MW!" }), _jsx(Typography, { fontSize: { xs: 16, md: 20 }, textAlign: "center", color: "#6F7276", marginBottom: { xs: '30px', md: '56px' }, children: "\uC804\uAD6D\uC758 \uACF5\uC7A5\uC8FC\uAC00 \uC5D4\uB77C\uC774\uD2BC\uACFC \uD568\uAED8\uD558\uACE0 \uC788\uC5B4\uC694." }), _jsx(Grid, { width: "100%", sx: {
                    '.slick-list': {
                        margin: { xs: '0 -20px', md: '0 -24px' },
                    },
                    '.slick-slide > div': {
                        padding: { xs: '0 10px', md: '0 12px' },
                    },
                    '.slick-dots': {
                        position: 'inherit',
                        marginTop: 1,
                        'li button:before': {
                            fontSize: 12,
                        },
                    },
                }, children: _jsx(SliderComponent, { slidesToShow: isMobile ? 1 : 3, dots: true, infinite: false, prevArrow: null, nextArrow: null, children: list.map((image, i) => (_jsx(Grid, { sx: {
                            outline: 'none',
                            img: {
                                maxWidth: { xs: 300, md: 448 },
                                width: '100%',
                                height: 'auto',
                                marginX: 'auto',
                            },
                        }, children: process.env.NEXT_PUBLIC_IS_NEXT_JS === 'true' ||
                            process.env.NEXT_PRIVATE_IS_NEXT_JS === 'true' ? (_jsx(Image, { ...image })) : (_jsx("img", { ...image })) }, i))) }) })] }));
}
